import { Trans } from '@lingui/macro'
import {
  ALLOCATION_COMMITTEE_GROUP,
  authRoles,
  BOARD_GROUP,
  CMHC_GROUP
} from '../../../auth/authRoles'
import {
  CBTI_RECORD_TYPE,
  CHGF_CB_RECORD_TYPE,
  CHGF_PP_RECORD_TYPE,
  CHGF_RI_RECORD_TYPE,
  GREEN_KICKSTARTER_RECORD_TYPE,
  NLCHGF_RECORD_TYPE,
  NPF_CB_RECORD_TYPE,
  NPF_PPD_RECORD_TYPE,
  NPF_RI_RECORD_TYPE, STF_LP_RECORD_TYPE,
  STF_SIP_RECORD_TYPE
} from '../../../services/sfAuth/sfData/sfOpportunity'

export const committeeInfo = {
  AC: {
    header: <Trans>NAVIGATIONS_EXECUTIVE_SUMMARIES</Trans>,
    auth: authRoles.allocationCommittee,
    toValidateStages: ['AC'],
    recordTypes: [
      STF_LP_RECORD_TYPE,
      STF_SIP_RECORD_TYPE,
      CBTI_RECORD_TYPE,
      GREEN_KICKSTARTER_RECORD_TYPE
    ],
    showTables: ['toValidate', 'denied', 'validated'],
    group: ALLOCATION_COMMITTEE_GROUP
  },
  SC: {
    header: <Trans>NAVIGATIONS_EXECUTIVE_SUMMARIES</Trans>,
    auth: authRoles.selectionCommittee,
    toValidateStages: ['SC'],
    recordTypes: [
      CHGF_CB_RECORD_TYPE,
      CHGF_PP_RECORD_TYPE,
      CHGF_RI_RECORD_TYPE,
      NPF_CB_RECORD_TYPE,
      NPF_PPD_RECORD_TYPE,
      NPF_RI_RECORD_TYPE,
      NLCHGF_RECORD_TYPE
    ],
    showTables: ['toValidate']
  },
  BOARD: {
    header: <Trans>GRANTS_ROUTES_BOARD_EXECUTIVE_SUMMARIES_LABEL</Trans>,
    auth: authRoles.board,
    toValidateStages: ['Board'],
    recordTypes: [STF_LP_RECORD_TYPE, STF_SIP_RECORD_TYPE, CBTI_RECORD_TYPE],
    showTables: ['toValidate', 'denied', 'validated'],
    group: BOARD_GROUP
  },
  CMHC: {
    header: <Trans>GRANTS_ROUTES_CMHC_EXECUTIVE_SUMMARIES_LABEL</Trans>,
    auth: authRoles.cmhc,
    toValidateStages: ['CMHC'],
    recordTypes: [STF_LP_RECORD_TYPE, STF_SIP_RECORD_TYPE, CBTI_RECORD_TYPE],
    showTables: ['toValidate', 'denied', 'validated'],
    group: CMHC_GROUP
  }
}

export const COMMITTEES_ALLOWING_CONFLICT_OF_INTEREST = ['SC', 'AC']

export const getCommitteeValidatedStages = (committeeType: string): string[] => {
  const baseValidatedStages = [
    'Validated',
    'Awarded',
    'Contracted',
    'Operational',
    'Special scrutiny',
    'Finished',
    'Terminated'
  ]

  if (committeeType === 'SC') {
    return baseValidatedStages
  }

  return ['AC', 'Board', 'CMHC', ...baseValidatedStages]
}

export const stageSorting = {
  validated: {
    name: 'stageName',
    direction: 'asc'
  },
  toValidate: {
    name: 'date',
    direction: 'asc'
  },
  denied: {
    name: 'date',
    direction: 'asc'
  }
}
